import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';

import CompleteOrder from './CompleteOrder';
import CompleteExteriorSignangeSubmisson from './CompleteExteriorSignangeSubmisson';
import CompleteMerchandisingProgram from './CompleteMerchandisingProgram';
import { useSelector } from 'react-redux';
import { useActiveCart } from 'services/Data/CartService';
import { useActiveMerchandisingProgramQuote } from 'services/Data/MerchandisingProgramQuoteService';
import { useActiveExteriorSignageQuote } from 'services/Data/ExteriorSignageQuoteService';
import { useTranslation } from 'react-i18next';
import { IsImpersonationMode } from 'config/config';

const useStyles = makeStyles(() => ({
  pageFull: {
    width: '100%',
  },
  noItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cartFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const Cart = () => {
  const classes = useStyles();
  const accountReducer = useSelector(state => state.AccountReducer);
  const { t } = useTranslation();
  const dealerId = accountReducer?.profile?.dealer_Id;

  const { data: cart } = useActiveCart(accountReducer.isLoggedIn, false, IsImpersonationMode ? dealerId : null);
  const { data: merchandisingProgramQuote } = useActiveMerchandisingProgramQuote(accountReducer.isLoggedIn);
  const { data: exteriorSignageQuote } = useActiveExteriorSignageQuote(accountReducer.isLoggedIn);

  return (
    <Box className={classes.pageFull}>
      {(cart?.cartItems?.length ?? 0) + (cart?.cartWalls?.length ?? 0) + (cart?.cartToolings?.length ?? 0) > 0 ? (
        <CompleteOrder />
      ) : (
        ''
      )}
      {(exteriorSignageQuote?.quoteItems?.length ?? 0) > 0 ? <CompleteExteriorSignangeSubmisson /> : ''}

      {(merchandisingProgramQuote?.quoteItems?.length ?? 0) > 0 ? <CompleteMerchandisingProgram /> : ''}

      {(merchandisingProgramQuote?.quoteItems?.length ?? 0) === 0 &&
        (exteriorSignageQuote?.quoteItems?.length ?? 0) === 0 &&
        !cart && (
          <Box className={classes.noItem}>
            <Typography fontSize={20} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
              {t('NoItemInCart')}
            </Typography>
          </Box>
        )}
    </Box>
  );
};

export default Cart;
